exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".shake-list .table-filters li{line-height:34px;height:34px;list-style:none;display:inline-block}.shake-list .table-filters li:after{content:'|'}.shake-list .table-filters li:last-child:after{content:''}.shake-list .for-after-line{position:relative}.shake-list .for-after-line:after{content:'-';position:absolute;right:-3px;top:5px}.shake-list .for-after-line-pos{position:relative}.shake-list .for-after-line-pos:after{content:'-';position:absolute;right:-18px;top:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./examples/template/list/style.less
 ** module id = 226
 ** module chunks = 0
 **/